import React, { useMemo } from 'react';

import { useSelector } from 'react-redux';

import CardContainer from 'bundles/apex/card/container';
import { DealContactRolesCard } from './card';
import { groupByCategory, type DealType } from 'bundles/backoffice/contacts/groups';

import type { Deal } from 'bundles/apex/deals/types';
import type { Role } from 'bundles/backoffice/contacts/types';

export default function Contacts() {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  const deal: Deal = useSelector((state: any) => state.deal);
  const fields: Record<string, { required: boolean }> = useSelector((state: any) => state.fields);
  const roles: Role[] = useSelector((state: any) => state.options.availableContactRelationships);
  /* eslint-enable @typescript-eslint/no-explicit-any */

  const categories = useMemo(() => {
    let dealType: DealType;
    if (deal.dealType === 'sale') {
      dealType = 'sale';
    } else if (deal.dealType === 'lease') {
      dealType = 'lease';
    } else if (deal.dealType === 'buyer_rep') {
      dealType = 'buyerRep';
    } else if (deal.dealType === 'tenant_rep') {
      dealType = 'tenantRep';
    } else {
      dealType = 'other';
    }

    return groupByCategory(deal.contactRoles, roles, dealType, fieldName => fields[fieldName]?.required);
  }, [deal.contactRoles]);

  return (
    <CardContainer>
      {categories.map(category => (
        <DealContactRolesCard
          category={category}
          key={category.header}
        />
      ))}
    </CardContainer>
  );
}
